import Axios, {AxiosRequestConfig} from "axios";

interface StackItem {
    callback: () => void,
    prevTitle: string
}
export default class DialogStack {
    private static instance: DialogStack;

    private stack: StackItem[] = [];

    protected onPopState: (e:PopStateEvent) => void;

    static getInstance(): DialogStack {
        if (!DialogStack.instance) {
            DialogStack.instance = new DialogStack();
        }

        return DialogStack.instance;
    }


    constructor() {
        this.onPopState = e => {
            this.pop();
        };

        window.addEventListener('popstate', this.onPopState);
    }

    public push(url: string, newTitle: string, callback: ()=>void){
        this.stack.push({
            callback: callback,
            prevTitle: document.title
        });

        window.history.pushState(null, "", url);
    };

    public pop(){
        let item = this.stack.pop();
        document.title = item.prevTitle;

        item.callback();
    }
}